import { ProductLockRequestEntity } from "@features/catalog/domain";
import { getSizedImage, ImageSize } from "@features/shared/data";
import { formatDate } from "date-fns";
import { ProductLockRequestModel } from "../models/product-lock-request.model";

export function mapProductLockRequest(
  productLockRequest: ProductLockRequestModel,
): ProductLockRequestEntity {
  return {
    id: productLockRequest.id,
    status: productLockRequest.status,
    sku: productLockRequest.sku,
    name: productLockRequest.productName,
    images: {
      small: getSizedImage(productLockRequest.productImage, ImageSize.small),
    },
    requestedQuantity: productLockRequest.requestedQuantity,
    acceptedQuantity: productLockRequest.acceptedQuantity,
    expectedDailyOrders: productLockRequest.expectedDailyOrders,
    createdAt: formatDate(productLockRequest.createdAt, "dd-MM-yyyy"),
    rejectionReason: productLockRequest.rejectionReason,
  };
}
